import * as React from 'react';

import {
  FormControl,
  FormHelperText,
  MenuItem,
  OutlinedInput
} from '@material-ui/core';
import {
  Alignment,
  PlaceHolder,
  SelectInput,
  SelectLabel
} from '@components/field-builder/styles';
import {
  Field,
  FieldDefinition,
  FieldOption
} from '@models/field-builder/field';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    '@media (max-width: 580px)': {
      maxWidth: '100%'
    }
  },
  menuItem: {
    '@media (max-width: 580px)': {
      fontSize: 10,
      minHeight: 30
    }
  }
}));

export const FieldSelect = (
  {
    id,
    setValueMethod,
    label,
    width,
    options,
    labelPosition,
    placeHolder,
    value,
    hidden,
    helperText,
    maxWidth,
    disabled,
    hasError
  }: Field) => {
  const css = useStyles();
  const getWidth: number = (width || FieldDefinition.defaultWidth);
  const handleChange = event => {
    event.preventDefault();
    if (!setValueMethod) {
      console.error(`No 'setValueMethod' found for the field: ${id}`);
      return;
    }
    setValueMethod(event.target.value);
  };
  return (
    <FormControl error={hasError}>
      <Alignment labelPosition={labelPosition} hidden={hidden}>
        <SelectLabel paddingBottom={true}>{label}</SelectLabel>
        <SelectInput
          displayEmpty={true}
          name={id}
          className={css.root}
          style={{
            minWidth: getWidth,
            maxWidth
          }}
          value={value || ''}
          autoComplete='off'
          onChange={handleChange}
          disabled={disabled}
          input={
            <OutlinedInput
              notched={false}
              labelWidth={getWidth}
              id={id}
              name={id}
              margin='dense'
            />
          }
        >
          <MenuItem value='' className={css.menuItem}>
            <PlaceHolder>{placeHolder}</PlaceHolder>
          </MenuItem>
          {options?.map((option: FieldOption) => {
            return (
              <MenuItem
                key={option.key}
                value={option.key}
                className={css.menuItem}
                disabled={option.disabled}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </SelectInput>
      </Alignment>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};



// WEBPACK FOOTER //
// ./src/components/field-builder/field-select.tsx